import { render, staticRenderFns } from "./carmonthRenior.vue?vue&type=template&id=27087823&"
import script from "./carmonthRenior.vue?vue&type=script&lang=js&"
export * from "./carmonthRenior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports